import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UrlBuilder from '../urlBuilder/UrlBuilder'

export default class Tile extends Component {
   
  render() {    
    const { img, textContent, url } = this.props
    return(
        <div className="os-flex-grid__col" >
            <article className="c-category-card c-category-card--icon">
                <a href={ UrlBuilder( { url: url, buildURL: true } ) }>
                    <img src={ img } alt= { textContent } />
                    <h3 className="o-heading-gamma mb-0">{ textContent }</h3>
                </a>
            </article>
        </div>
    )
  }
}

Tile.propTypes = {
    img: PropTypes.string.isRequired,
    textContent: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}